import { createSchema } from './dbschema';

export class IndexedDbClient {
  constructor(vids, cb) {
    this.dbInstances = {};
    this.storeInstances = {};
    this.databases = [];
    if (!('indexedDB' in window)) {
      console.log('This browser doesn\'t support IndexedDB');
      return;
    }
    this.databases = createSchema(vids);
    this.databases.forEach(db => {
      this.connectDB(db.nm, db.stores, db.ver, (err, res) => {
        if (err) {
          console.log("Error while creating database " + err);
          cb(err);
        } else {
          console.log("Successfully connection get established");
          cb(null);
        }
      });
    });
  }

  connectDB = (dbName, store_stack, ver, cb) => {
    var openRequest = indexedDB.open(dbName, ver);
    openRequest.onupgradeneeded = (e) => {
      this.dbInstances[dbName] = openRequest.result;
      var upgradeTransaction = e.target.transaction;
      store_stack.forEach((store, i) => {
        if (store && store.nm) {
          if (this.dbInstances && !this.dbInstances[dbName].objectStoreNames.contains(store.nm)) {
            this.createStore(dbName, store);
          } else {
            this.storeInstances[store.nm] = upgradeTransaction.objectStore(store.nm);
          }
        }
        if (store && store.indexes) {
          store.indexes.forEach((index) => {
            if (!this.storeInstances[store.nm].indexNames.contains(index.nm)) {
              this.createIndex(store.nm, index);
            }
          });
        }
      });
      //TODO: Delete stores and indexes which are deleted from dbschema
    };

    openRequest.onsuccess = () => {
      this.dbInstances[dbName] = openRequest.result;
      cb(null, this.dbInstances);
    };
    openRequest.onerror = (e) => {
      cb(e, null);
    };
  }

  createStore = (dbName, storeObj) => {
    var objStore = this.dbInstances[dbName].createObjectStore(storeObj.nm, storeObj.keyPath);
    this.storeInstances[storeObj.nm] = objStore;
  }

  createIndex = (storeNm, indexObj) => {
    this.storeInstances[storeNm].createIndex((indexObj.nm || indexObj.key), (indexObj.key), indexObj.options);
  }

  openTransaction = (func, params) => {
    return new Promise((resolve, reject) => {
      try {
        var transaction = this.dbInstances[params.dbNm].transaction(params.storeNm, params.oprMode);
        var objectStore = transaction.objectStore(params.storeNm);
        transaction.oncomplete = () => {
          if (!transaction.isOprnDone) reject("Transaction is closed");
        }
        transaction.onerror = () => {
          if (!transaction.isOprnDone) reject("Transaction is closed");
        }

        func(transaction, objectStore, params, (err, result) => {
          if (err) reject(err);
          else resolve(result);
        });
      }
      catch (e) {
        reject(e);
      }
    });
  }

  transactionHandler = (transaction, cb) => {
    transaction.oncomplete = () => {
      if (!transaction.isOprnDone) cb("Transaction is closed");
    }
    transaction.onerror = () => {
      if (!transaction.isOprnDone) cb("Transaction is closed");
    }
  }

  operationHandler = (transaction, request, cb) => {
    request.onsuccess = (e) => {
      let result;
      if (request.onSuccessMsg) result = request.onSuccessMsg;
      else result = e.target.result;
      cb(null, result);
      transaction.isOprnDone = true; // If operation get done set to true
    };
    request.onerror = (e) => {
      cb(request.onErrorMsg + e);
      transaction.isOprnDone = true; // If operation get done set to true
    };
  }

  addSingleRecord(dbNm, storeNm, record, update) {
    let records = [record];
    let oprMode = "readwrite";
    return this.openTransaction(this.__addRecords, { dbNm, storeNm, records, update, oprMode });
  }

  addMultipleRecords(dbNm, storeNm, records, update) {
    let oprMode = "readwrite";
    return this.openTransaction(this.__addRecords, { dbNm, storeNm, records, update, oprMode })
  }

  addSingleRecordWithKey(dbNm, storeNm, record) {
    /**
     * record is object contain key and value to be stored
     */
    let records = [record];
    let oprMode = "readwrite";
    return this.openTransaction(this.__addRecords, { dbNm, storeNm, records, oprMode })
  }
  addMultipleRecordsWithKeys(dbNm, storeNm, records) {
    /**
     * record is array object contain key and value to be stored
     */
    let oprMode = "readwrite";
    return this.openTransaction(this.__addRecords, { dbNm, storeNm, records, oprMode})
  }

  __addRecords = (transaction, objectStore, params, cb) => {
    let valLength = params.records.length;
    var i, req;
    if (!params.i) i = 0;
    else i = params.i;

    if (i < valLength) {
      if (params.records[i].key && params.records[i].value) req = objectStore.put(params.records[i].value, params.records[i].key); // This is only needed for object stores that have an autoIncrement primary key to update any record
      else {
        if (params.update) {
          // 'put' function can only update the data of store which don't have auto increment key path
          req = objectStore.put(params.records[i]);
        }
        else req = objectStore.add(params.records[i]);
      }
      req.onsuccess = (e) => {
        i++;
        params.i = i;
        this.__addRecords(transaction, objectStore, params, cb);
      }
      req.onerror = (e) => {
        cb("Error accured while adding records " + e.target.error);
        transaction.isOprnDone = true;
      }
    } else if (i === valLength) {
      cb(null);
      transaction.isOprnDone = true;
    }
  }

  clearStore(dbNm, storeNm) {
    let oprMode = "readwrite";
    return this.openTransaction(this.__clearStore, { dbNm, storeNm, oprMode });
  }

  __clearStore = (transaction, objectStore, params, cb) => {
    var req = objectStore.clear();
    req.onSuccessMsg = "Store get cleared successfully";
    req.onErrorMsg = "Error accured while clearing store";
    this.operationHandler(transaction, req, cb);
  }

  getAllRecords(dbNm, storeNm, indexNm, value) {
    let oprMode = "readonly";
    return this.openTransaction(this.__getAllRecords, { dbNm, storeNm, oprMode, indexNm, value});
  }

  __getAllRecords = (transaction, objectStore, params, cb) => {
    let req;

    if (params.indexNm && params.value) {
      var index = objectStore.index(params.indexNm);
      req = index.getAll(params.value);
    } else req = objectStore.getAll();

    req.onErrorMsg = "Error accured while getting store data";
    this.operationHandler(transaction, req, cb);
  }

  getDataByRange = (dbNm, storeNm, indexNm, lowerBound, upperBound, limit, sort) => {
    let oprMode = "readonly";
    return this.openTransaction(this.__getDataByRange, { dbNm, storeNm, oprMode, indexNm, lowerBound, upperBound, limit, sort });
  }

  __getDataByRange = (transaction, objectStore, params, cb) => {
    var keyRangeValue, resp = [], i = 0, req;
    var sort = params.sort === 'asc' ? "next" : "prev";
    if (params.lowerBound && params.upperBound) keyRangeValue = IDBKeyRange.bound(params.lowerBound, params.upperBound);
    else if (params.lowerBound) keyRangeValue = IDBKeyRange.lowerBound(params.lowerBound, true);  // second parameter true indicates that All keys > lowerbound
    else if (params.upperBound) keyRangeValue = IDBKeyRange.upperBound(params.upperBound, true); // second parameter true indicates that All keys < upperbound
    else return cb("Lowerbound and upperbound is missing");

    if (params.indexNm) {
      let index = objectStore.index(params.indexNm);
      req = index.openCursor(keyRangeValue, sort); //  'prev' = down from the record with the biggest key
    } else req = objectStore.openCursor(keyRangeValue, sort);

    req.onsuccess = (e) => {
      var cursor = e.target.result;
      if (!params.limit) {
        if (cursor) {
          resp.push(cursor.value);
          cursor.continue();
        } else {
          cb(null, resp);
          transaction.isOprnDone = true;
        }
      } else {
        if (cursor && i < params.limit) {
          resp.push(cursor.value);
          i += 1;
          cursor.continue();
        } else {
          cb(null, resp);
          transaction.isOprnDone = true;
        }
      }
    }
    req.onerror = () => {
      cb("Error while getting data by range");
      transaction.isOprnDone = true;
    }
  }

  getValueByKey(dbNm, storeNm, key, indexNm) {
    let oprMode = "readonly";
    return this.openTransaction(this.__getValueByKey, { dbNm, storeNm, oprMode, key, indexNm });
  }

  __getValueByKey = (transaction, objectStore, params, cb) => {
    let req;
    if (params.indexNm) {
      let index = objectStore.index(params.indexNm);
      req = index.get(params.key);
    } else req = objectStore.get(params.key);

    req.onErrorMsg = "Error accured while getting value";
    this.operationHandler(transaction, req, cb);
  }

  getRecordCount(dbNm, storeNm, indexNm, lowerBound, upperBound) {
    let oprMode = "readonly";
    return this.openTransaction(this.__getRecordCount, { dbNm, storeNm, oprMode, indexNm, lowerBound, upperBound});
  }

  __getRecordCount = (transaction, objectStore, params, cb ) => {
    let index = objectStore.index(params.indexNm);
    var keyRangeValue;

    if (params.lowerBound && params.upperBound) keyRangeValue = IDBKeyRange.bound(params.lowerBound, params.upperBound);
    else if (params.lowerBound) keyRangeValue = IDBKeyRange.lowerBound(params.lowerBound, true);  // second parameter true indicates that All keys > lowerbound
    else keyRangeValue = IDBKeyRange.upperBound(params.upperBound, true); // second parameter true indicates that All keys < upperbound

    var req = index.count(keyRangeValue);
    req.onErrorMsg = "Error accured while getting count of records with indexing";
    this.operationHandler(transaction, req, cb);
  }

  deleteRecord(dbNm, storeNm, key) {
    let oprMode = "readwrite";
    return this.openTransaction(this.__deleteRecord, { dbNm, storeNm, oprMode, key });
  }

  __deleteRecord = (transaction, objectStore, params, cb ) => {
    var req = objectStore.delete(params.key);
    req.onErrorMsg = "Error accured while deleting value";
    this.operationHandler(transaction, req, cb);
  }

  deleteDB(dbName, cb) {
    /*
    If the database already exists and there are open connections that don’t close in response to a versionchange event,
    the request will be blocked until they all close. If the request is successful request’s result will be null.
    */

    this.dbInstances[dbName].close(); //   Before deleting any database need to close that database connection

    let deleteRequest = indexedDB.deleteDatabase(dbName);

    deleteRequest.onsuccess = function (e) {
      cb(null);
    };

    deleteRequest.onerror = function (e) {
      cb("Error while deleting database");
    };
  }
}